import { render, staticRenderFns } from "./ProductCardGrid.vue?vue&type=template&id=6423ee9f"
import script from "./ProductCardGrid.vue?vue&type=script&lang=js"
export * from "./ProductCardGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports